import React, { useEffect, useState, useRef } from "react";
import Table from "react-bootstrap/Table";
import { getLoggenInToken, getLoggedInUser } from "../../../store/selectors/AuthSelectors";
import { connect } from "react-redux";
import swal from "sweetalert";
import { toast } from "react-toastify";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import { withRouter } from "../../../App";
import { getCandidates } from "../../../store/selectors/Candidates/CandidatesList";
import { del, get, post } from "../../../services/api";
import SendEmail from "../Common/SendEmail";
import dayjs from "dayjs";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import { SVGICON } from "../../constant/theme";

const RestrictCandidates = ({ selectedCompany, token, candidates, loggedInUser }) => {
  const [candidateList, setCandidateList] = useState([]);
  const [restrictedCandidates, setRestrictedCandidates] = useState([]);
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [weeklyAttendance, setWeeklyAttendance] = useState([]);
  const [attendanceModal, setAttendanceModal] = useState(false);
  const [submitAttendanceModal, setSubmitAttendanceModal] = useState(false);
  const [attendanceDays, setAttendanceDays] = useState([]);
  const [currentCandidate, setCurrentCandidate] = useState(null);
  const [monthlyAttendance, setMonthlyAttendance] = useState([]);
  const [monthlyModal, setMonthlyModal] = useState(false);
  const [isSavingAttendance, setIsSavingAttendance] = useState(false);
  const [isSubmittingApprove, setIsSubmittingApprove] = useState(false);
  const [attendanceStatus, setAttendanceStatus] = useState(['PRESENT', 'ABSENT', 'LEAVE']);
  const [searchQuery, setSearchQuery] = useState("");
  const [invoiceCandidates, setInvoiceCandidates] = useState([]);
  const [selectedInvoiceCandidates, setSelectedInvoiceCandidates] = useState([]);
  const [overTimePayRate, setOverTimePayRate] = useState([]);
  const [bankHolidayOvertimePayRate, setBankHolidayOvertimePayRate] = useState([]);
  const [nightRatePayRate, setNightRatePayRate] = useState([]);
  
  // Current week range for attendance
  const [weekRange, setWeekRange] = useState({
    startDate: new Date(),
    endDate: new Date(new Date().setDate(new Date().getDate() + 6))
  });
  
  const emailComponentRef = useRef();

  useEffect(() => {
    if (candidates) {
      setCandidateList(
        candidates.map((candidate) => ({
          value: candidate._id,
          label: `${candidate?.firstName} ${candidate?.lastName}`,
        }))
      );
    }
  }, [candidates]);
  // Fetch restricted candidates for the selected company
  const fetchRestrictedCandidates = async () => {
    if (selectedCompany?._id) {
      try {
        const response = await get(`/api/restrict-candidate/company/${selectedCompany?._id}`, token);
        setRestrictedCandidates(response);
      } catch (error) {
        console.error("Error fetching restricted candidates:", error);
        toast.error("Failed to load restricted candidates.");
      }
    }
  };

  // Add selected candidates to the restricted list
  const handleRestrictCandidates = async () => {
    if (!selectedCandidates || selectedCandidates.length === 0) {
      toast.warn("Please select at least one candidate to restrict.");
      return;
    }
    try {
      const candidatesToRestrict = selectedCandidates.map(candidate => ({
        companyId: selectedCompany?._id,
        candidateId: candidate?.value,
        candidateName: candidate?.label,
      }));
      const res = await post(
        "/api/restrict-candidate",
        candidatesToRestrict,
        token
      );
      toast.success("Candidates restricted successfully.");
      setSelectedCandidates([]);
      fetchRestrictedCandidates();
    } catch (error) {
      console.error("Error restricting candidates:", error);
      toast.error("Failed to restrict candidates.");
    }
  };

  // Remove a candidate from the restricted list
  const handleRemoveCandidate = async (id) => {
    swal({
      title: "Are you sure?",
      text: "This action will remove the candidate from the restricted list.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          await del(`/api/restrict-candidate/${id}`, token);
          toast.success("Candidate removed from blocked list successfully.");
          fetchRestrictedCandidates();
        } catch (error) {
          console.error("Error removing candidate:", error);
          toast.error("Failed to remove candidate.");
        }
      }
    });
  };

  // Fetch weekly attendance for all candidates
  const fetchWeeklyAttendance = async () => {
    try {
      const payload = {
        weekStartDate: weekRange.startDate,
        weekEndDate: weekRange.endDate,
        requirementId: selectedCompany?._id, 
      };

      const response = await post("/api/timesheet/get/weekly", payload, token);
      setWeeklyAttendance(response?.data?.data || []);
    } catch (error) {
      setWeeklyAttendance([]);
      console.error("Error fetching weekly attendance:", error);
      toast.error("Error fetching weekly attendance.");
    }
  };
  
  // Fetch monthly attendance for a candidate
  const fetchMonthlyAttendance = async (candidate) => {
    try {
      const firstDate = dayjs(weekRange.startDate)
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastDate = dayjs(weekRange.startDate)
        .endOf("month")
        .format("YYYY-MM-DD");

      const payload = {
        weekStartDate: firstDate,
        weekEndDate: lastDate,
        candidateId: candidate.candidateId,
        requirementId: selectedCompany?._id, 
      };

      const response = await post("/api/timesheet/get/weekly", payload, token);
      setMonthlyAttendance(response?.data?.data || []);
      setMonthlyModal(true);
    } catch (error) {
      console.error("Error fetching monthly attendance:", error);
    }
  };

  // Get all weekdays in the range
  const getWeekDaysInRange = (startDate, endDate) => {
    const dates = [];
    let currentDate = new Date(startDate);
    while (currentDate <= new Date(endDate)) {
      dates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates;
  };

  // Open attendance modal for a candidate
  const openAttendanceModal = (candidate) => {
    setCurrentCandidate(candidate);

    const currentCandidateAttendanceStatusList = weeklyAttendance.filter(
      (att) => att.candidateId === candidate.candidateId
    );

    // Get all weekdays in the range
    const weekDaysInRange = getWeekDaysInRange(
      weekRange.startDate,
      weekRange.endDate
    );

    // Map week days to their attendance status
    const attendanceDays = weekDaysInRange.map((date) => {
      const utcDate = new Date(date); // Convert to UTC date
      const formattedDate = utcDate.toISOString().split("T")[0]; // Format as YYYY-MM-DD

      // Find matching attendance status
      const attendanceStatus = currentCandidateAttendanceStatusList.find(
        (currentDate) => currentDate.jobDate.split("T")[0] === formattedDate
      );

      return {
        day: utcDate.toLocaleDateString("en-GB", {
          weekday: "long",
          timeZone: "UTC", // Consistently use UTC
        }),
        date: formattedDate, // Keep consistent date format
        status: attendanceStatus ? attendanceStatus.status : "", // Default to empty if not found
        hours: attendanceStatus ? attendanceStatus.hours : 0,
        overTimeHours: attendanceStatus ? attendanceStatus.overTimeHours : 0,
        bankHolidayOverTimeHours: attendanceStatus ? attendanceStatus.bankHolidayOverTimeHours : 0,
        nightRateHours: attendanceStatus ? attendanceStatus.nightRateHours : 0,
      };
    });

    setAttendanceDays(attendanceDays); // Set the attendance days
    setAttendanceModal(true); // Open modal
  };

  // Open submit attendance modal for a candidate
  const openSubmitAttendanceModal = (candidate) => {
    setCurrentCandidate(candidate);
    const candidateAttendance = weeklyAttendance.filter(
      (att) => att.candidateId === candidate.candidateId
    );
    setAttendanceDays(candidateAttendance);
    setSubmitAttendanceModal(true);
  };

  // Handle attendance status change
  const handleStatusChange = (index, value) => {
    setAttendanceDays((prevDays) => {
      const updatedDays = prevDays.map((day, idx) =>
        idx === index ? { ...day, status: value } : day
      );
      if (value !== "PRESENT") {
        handleHoursChange(index, "");
        handleOverTimeHoursChange(index, "");
        handleBankHolidayHoursChange(index, "");
        handleNightRateHoursChange(index, "");
      }
      return updatedDays;
    });
  };

  // Handle hours change
  const handleHoursChange = (index, value) => {
    setAttendanceDays((prevDays) => {
      return prevDays.map((day, idx) =>
        idx === index ? { ...day, hours: value } : day
      );
    });
  };

  // Handle overtime hours change
  const handleOverTimeHoursChange = (index, value) => {
    setAttendanceDays((prevDays) => {
      return prevDays.map((day, idx) =>
        idx === index ? { ...day, overTimeHours: Number(value) || 0 } : day
      );
    });
  };

  // Handle bank holiday hours change
  const handleBankHolidayHoursChange = (index, value) => {
    setAttendanceDays((prevDays) => {
      return prevDays.map((day, idx) =>
        idx === index ? { ...day, bankHolidayOverTimeHours: Number(value) || 0 } : day
      );
    });
  };

  // Handle night rate hours change
  const handleNightRateHoursChange = (index, value) => {
    setAttendanceDays((prevDays) => {
      return prevDays.map((day, idx) =>
        idx === index ? { ...day, nightRateHours: Number(value) || 0 } : day
      );
    });
  };

  // Mark attendance for a candidate
  const markAttendance = async () => {
    if (isSavingAttendance) return;
    setIsSavingAttendance(true);
    try {
      const promises = attendanceDays.map(
        async ({ day, date, status, hours, overTimeHours, bankHolidayOverTimeHours, nightRateHours }) => {
          if (!status) return;
          const payload = {
            jobId: selectedCompany?._id,
            companyId: selectedCompany?._id,
            candidateId: currentCandidate?.candidateId,
            jobDay: day,
            jobDate: date,
            status,
            hours: hours || 0,
            overTimeHours: overTimeHours || 0,
            bankHolidayOverTimeHours: bankHolidayOverTimeHours || 0,
            nightRateHours: nightRateHours || 0,
          };
          return post("/api/timesheet/add", payload, token);
        }
      );
      await Promise.all(promises);
      fetchWeeklyAttendance(); // Refresh attendance after marking
      setAttendanceModal(false);
      toast.success("Attendance has been marked successfully.");
    } catch (error) {
      toast.error("Error while marking attendance. Please try again");
      console.error("Error marking attendance:", error);
    } finally {
      setIsSavingAttendance(false);
    }
  };

  // Submit and approve attendance
  const submitAttendance = async () => {
    if (isSubmittingApprove) return;
    setIsSubmittingApprove(true);
    try {
      const promises = attendanceDays.map(async (day) => {
        const payload = {
          jobId: selectedCompany?._id,
          companyId: selectedCompany?._id,
          candidateId: currentCandidate?.candidateId,
          jobDay: day.jobDay,
          jobDate: day.jobDate,
          isSubmitted: true,
          status: day.status || "",
          hours: day.hours || 0,
          overTimeHours: day.overTimeHours || 0,
          bankHolidayOverTimeHours: day.bankHolidayOverTimeHours || 0,
          nightRateHours: day.nightRateHours || 0,
        };
        return post("/api/timesheet/add", payload, token);
      });
      await Promise.all(promises);
      fetchWeeklyAttendance(); // Refresh the weekly attendance
      setSubmitAttendanceModal(false);
      toast.success("Attendance has been submitted and approved successfully.");
    } catch (error) {
      toast.error("Error while submitting attendance. Please try again.");
      console.error("Error submitting attendance:", error);
    } finally {
      setIsSubmittingApprove(false);
    }
  };

  // Generate invoice for a candidate
  const generateInvoice = async (candidate) => {
    const response = await post(
      "/api/timesheet/invoice",
      {
        ...candidate,
        weekStartDate: weekRange.startDate,
        weekEndDate: weekRange.endDate,
        companyId: selectedCompany?._id,
      },
      token
    );
    const data = response.data;
    if (data && data.filedata) {
      const byteCharacters = atob(data.filedata);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);

        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      const blob = new Blob(byteArrays, {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      const downloadLink = document.createElement("a");
      const url = URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = data.filename;
      downloadLink.click();
      URL.revokeObjectURL(url);
    }
    fetchWeeklyAttendance();
  };

  // Generate consolidated invoice for selected candidates
  const generateConsolidatedInvoice = async (selectedCandidates) => {
    const response = await post(
      "/api/timesheet/consolidated-invoice",
      {
        selectedCandidates,
        weekStartDate: weekRange.startDate,
        weekEndDate: weekRange.endDate,
        companyId: selectedCompany?._id,
      },
      token
    );
    const data = response.data;
    if (data && data.filedata) {
      const byteCharacters = atob(data.filedata);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);

        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      const blob = new Blob(byteArrays, {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      const downloadLink = document.createElement("a");
      const url = URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = data.filename;
      downloadLink.click();
      URL.revokeObjectURL(url);
    }
    fetchWeeklyAttendance();
  };

  // Send email to a candidate
  const sendEmail = (candidate) => {
    setCurrentCandidate(candidate);
    emailComponentRef.current.showEmailModal();
  };
  
  useEffect(() => {
    if (selectedCompany) {
      fetchRestrictedCandidates();
      fetchWeeklyAttendance();
    }
  }, [selectedCompany]);

  return (
    <Card className="p-3">
      <Tab.Container id="candidate-tabs" defaultActiveKey="restrict">
        <Nav variant="tabs" className="mb-3">
          <Nav.Item>
            <Nav.Link eventKey="restrict">Restrict Candidates</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="attendance">Attendance & Invoices</Nav.Link>
          </Nav.Item>
        </Nav>

        <Tab.Content>
          {/* Restrict Candidates Tab */}
          <Tab.Pane eventKey="restrict">
            <h3 className="mb-3">Restrict Candidates</h3>

            <Form className="mb-4">
              <Form.Group controlId="candidateSelect">
                <Form.Label>Select Candidates</Form.Label>
                <Select
                  isMulti
                  options={candidateList}
                  value={selectedCandidates}
                  onChange={setSelectedCandidates}
                  placeholder="Select candidates to restrict"
                  isOptionDisabled={(option) =>
                    restrictedCandidates.some((restricted) => restricted.candidateId === option.value)
                  }
                />
              </Form.Group>
              <Button className="mt-4" variant="primary" onClick={handleRestrictCandidates}>
                Restrict Candidates
              </Button>
            </Form>

            <h4>Restricted Candidates</h4>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Candidate Name</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {restrictedCandidates?.length > 0 ? (
                  restrictedCandidates?.map((candidate, index) => (
                    <tr key={candidate._id}>
                      <td>{index + 1}</td>
                      <td>{candidate.candidateName || "--"}</td>
                      <td>
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => handleRemoveCandidate(candidate._id)}
                        >
                          Remove
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No restricted candidates found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Tab.Pane>

          {/* Attendance & Invoices Tab */}
          <Tab.Pane eventKey="attendance">
            <div className="mb-4 d-flex justify-content-between align-items-center">
              <div>
                <h3>Candidates</h3>
              </div>
              <div className="d-flex align-items-center">
                <div className="me-3">
                  <Form.Group controlId="weekPicker">
                    <Form.Label className="mb-1">Week:</Form.Label>
                    <Form.Control
                      type="date"
                      value={dayjs(weekRange.startDate).format("YYYY-MM-DD")}
                      onChange={(e) => {
                        const startDate = new Date(e.target.value);
                        const endDate = new Date(startDate);
                        endDate.setDate(startDate.getDate() + 6);
                        setWeekRange({ startDate, endDate });
                      }}
                    />
                  </Form.Group>
                </div>
                <Button
                  variant="primary"
                  className="purple-btn"
                  onClick={() => {
                    if (selectedInvoiceCandidates.length > 0) {
                      generateConsolidatedInvoice(selectedInvoiceCandidates);
                    } else {
                      toast.warn("Please select at least one candidate");
                    }
                  }}
                >
                  Generate Consolidated Invoice
                </Button>
              </div>
            </div>

            <div className="mb-3">
              <Form.Control
                type="text"
                placeholder="Search by candidate name..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            <Tab.Container id="attendance-view" defaultActiveKey="list">
              <div className="d-flex justify-content-end mb-3">
                <Nav className="viewMode-tabs">
                  <Nav.Item>
                    <Nav.Link eventKey="list">
                      <i className="fas fa-list-ul"></i>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="grid">
                      <i className="fas fa-th"></i>
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </div>
              
              <Tab.Content>
                {/* List View */}
                <Tab.Pane eventKey="list">
                  {weeklyAttendance.filter(c => 
                    c.candidateName?.toLowerCase().includes(searchQuery.toLowerCase())
                  ).length > 0 ? (
                    <>
                      <div className="mb-3">
                        <Button 
                          variant="primary"
                          style={{ backgroundColor: '#6f42c1', borderColor: '#6f42c1', margin: '0 5px 5px 0' }}
                          onClick={() => {
                            if (selectedInvoiceCandidates.length > 0) {
                              // Get unique candidates (to avoid duplicates)
                              const uniqueCandidates = [];
                              selectedInvoiceCandidates.forEach(candidate => {
                                if (!uniqueCandidates.some(c => c.candidateId === candidate.candidateId)) {
                                  uniqueCandidates.push(candidate);
                                }
                              });
                              setSelectedInvoiceCandidates(uniqueCandidates);
                              openAttendanceModal(uniqueCandidates[0]);
                            } else {
                              toast.warn("Please select at least one candidate");
                            }
                          }}
                        >
                          Mark Attendance for Selected
                        </Button>
                        
                        <Button 
                          variant="primary"
                          style={{ backgroundColor: '#6f42c1', borderColor: '#6f42c1', margin: '0 5px 5px 0' }}
                          onClick={() => {
                            if (selectedInvoiceCandidates.length > 0) {
                              // Get unique candidates (to avoid duplicates)
                              const uniqueCandidates = [];
                              selectedInvoiceCandidates.forEach(candidate => {
                                if (!uniqueCandidates.some(c => c.candidateId === candidate.candidateId)) {
                                  uniqueCandidates.push(candidate);
                                }
                              });
                              setSelectedInvoiceCandidates(uniqueCandidates);
                              openSubmitAttendanceModal(uniqueCandidates[0]);
                            } else {
                              toast.warn("Please select at least one candidate");
                            }
                          }}
                        >
                          Submit Attendance
                        </Button>
                        
                        <Button 
                          variant="primary"
                          style={{ backgroundColor: '#6f42c1', borderColor: '#6f42c1', margin: '0 5px 5px 0' }}
                          onClick={() => {
                            if (selectedInvoiceCandidates.length > 0) {
                              generateConsolidatedInvoice(selectedInvoiceCandidates);
                            } else {
                              toast.warn("Please select at least one candidate");
                            }
                          }}
                        >
                          Generate Invoice
                        </Button>
                      </div>
                      <Table striped bordered hover responsive>
                        <thead>
                          <tr>
                            <th>
                              <Form.Check
                                type="checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    const allCandidates = weeklyAttendance.filter(c => 
                                      c.candidateName?.toLowerCase().includes(searchQuery.toLowerCase())
                                    );
                                    setSelectedInvoiceCandidates(allCandidates);
                                  } else {
                                    setSelectedInvoiceCandidates([]);
                                  }
                                }}
                              />
                            </th>
                            <th>Ts.</th>
                            <th>Candidate Name</th>
                            <th className="text-center">AWR</th>
                            <th className="text-center">Ts.</th>
                            <th className="text-center">M</th>
                            <th className="text-center">T</th>
                            <th className="text-center">W</th>
                            <th className="text-center">T</th>
                            <th className="text-center">F</th>
                            <th className="text-center">S</th>
                            <th className="text-center">S</th>
                          </tr>
                        </thead>
                        <tbody>
                          {weeklyAttendance.filter(c => 
                            c.candidateName?.toLowerCase().includes(searchQuery.toLowerCase())
                          ).map((candidate, index) => {
                            // Group by candidate to show each candidate only once
                            const uniqueCandidate = weeklyAttendance.find(c => c.candidateId === candidate.candidateId);
                            if (!uniqueCandidate) return null;
                            
                            // Find all attendance records for this candidate
                            const candidateAttendance = weeklyAttendance.filter(c => c.candidateId === candidate.candidateId);
                            
                            // Create a map of weekday to attendance status
                            const weekDaysMap = {
                              'Monday': { status: '', isSubmitted: false },
                              'Tuesday': { status: '', isSubmitted: false },
                              'Wednesday': { status: '', isSubmitted: false },
                              'Thursday': { status: '', isSubmitted: false },
                              'Friday': { status: '', isSubmitted: false },
                              'Saturday': { status: '', isSubmitted: false },
                              'Sunday': { status: '', isSubmitted: false },
                            };
                            
                            // Fill in the map with actual attendance
                            candidateAttendance.forEach(att => {
                              if (att.jobDay) {
                                weekDaysMap[att.jobDay] = {
                                  status: att.status,
                                  isSubmitted: att.isSubmitted,
                                };
                              }
                            });
                            
                            // Check if this candidate is selected for invoicing
                            const isSelected = selectedInvoiceCandidates.some(
                              selected => selected.candidateId === candidate.candidateId
                            );
                            
                            return (
                              <tr key={`${candidate.candidateId}-${index}`}>
                                <td>
                                  <Form.Check
                                    type="checkbox"
                                    checked={isSelected}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setSelectedInvoiceCandidates(prev => [
                                          ...prev.filter(c => c.candidateId !== candidate.candidateId),
                                          candidate
                                        ]);
                                      } else {
                                        setSelectedInvoiceCandidates(prev => 
                                          prev.filter(c => c.candidateId !== candidate.candidateId)
                                        );
                                      }
                                    }}
                                  />
                                </td>
                                <td>
                                  <div className="text-center">
                                    <i className="fas fa-check-circle text-success"></i>
                                  </div>
                                </td>
                                <td>{candidate.candidateName}</td>
                                <td className="text-center">
                                  <span className="text-danger">✕</span>
                                </td>
                                <td className="text-center">
                                  <i className="fas fa-check-circle text-success"></i>
                                </td>
                                <td className="text-center">
                                  {weekDaysMap['Monday'].status === 'PRESENT' ? 'P' : 
                                   weekDaysMap['Monday'].status === 'ABSENT' ? 'A' : 
                                   weekDaysMap['Monday'].status === 'LEAVE' ? 'L' : '-'}
                                </td>
                                <td className="text-center">
                                  {weekDaysMap['Tuesday'].status === 'PRESENT' ? 'P' : 
                                   weekDaysMap['Tuesday'].status === 'ABSENT' ? 'A' : 
                                   weekDaysMap['Tuesday'].status === 'LEAVE' ? 'L' : '-'}
                                </td>
                                <td className="text-center">
                                  {weekDaysMap['Wednesday'].status === 'PRESENT' ? 'P' : 
                                   weekDaysMap['Wednesday'].status === 'ABSENT' ? 'A' : 
                                   weekDaysMap['Wednesday'].status === 'LEAVE' ? 'L' : '-'}
                                </td>
                                <td className="text-center">
                                  {weekDaysMap['Thursday'].status === 'PRESENT' ? 'P' : 
                                   weekDaysMap['Thursday'].status === 'ABSENT' ? 'A' : 
                                   weekDaysMap['Thursday'].status === 'LEAVE' ? 'L' : '-'}
                                </td>
                                <td className="text-center">
                                  {weekDaysMap['Friday'].status === 'PRESENT' ? 'P' : 
                                   weekDaysMap['Friday'].status === 'ABSENT' ? 'A' : 
                                   weekDaysMap['Friday'].status === 'LEAVE' ? 'L' : '-'}
                                </td>
                                <td className="text-center">
                                  {weekDaysMap['Saturday'].status === 'PRESENT' ? 'P' : 
                                   weekDaysMap['Saturday'].status === 'ABSENT' ? 'A' : 
                                   weekDaysMap['Saturday'].status === 'LEAVE' ? 'L' : '-'}
                                </td>
                                <td className="text-center">
                                  {weekDaysMap['Sunday'].status === 'PRESENT' ? 'P' : 
                                   weekDaysMap['Sunday'].status === 'ABSENT' ? 'A' : 
                                   weekDaysMap['Sunday'].status === 'LEAVE' ? 'L' : '-'}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                      
                      {/* No buttons needed here since they're at the top now */}
                    </>
                  ) : (
                    <div className="text-center p-4">
                      <h4>No candidates found</h4>
                      <p>There are no candidates matching your search criteria.</p>
                    </div>
                  )}
                </Tab.Pane>

                {/* Grid View */}
                <Tab.Pane eventKey="grid">
                  <div className="row">
                    {weeklyAttendance.filter(c => 
                      c.candidateName?.toLowerCase().includes(searchQuery.toLowerCase())
                    ).length > 0 ? (
                      weeklyAttendance.filter(c => 
                        c.candidateName?.toLowerCase().includes(searchQuery.toLowerCase())
                      ).reduce((acc, current) => {
                        // Group by candidateId to avoid duplicates
                        const x = acc.find(item => item.candidateId === current.candidateId);
                        if (!x) {
                          return acc.concat([current]);
                        } else {
                          return acc;
                        }
                      }, []).map((candidate, index) => {
                        // Create a map of weekday to attendance status
                        const candidateAttendance = weeklyAttendance.filter(c => c.candidateId === candidate.candidateId);
                        const weekDaysMap = {
                          'Monday': { status: '', isSubmitted: false },
                          'Tuesday': { status: '', isSubmitted: false },
                          'Wednesday': { status: '', isSubmitted: false },
                          'Thursday': { status: '', isSubmitted: false },
                          'Friday': { status: '', isSubmitted: false },
                          'Saturday': { status: '', isSubmitted: false },
                          'Sunday': { status: '', isSubmitted: false },
                        };
                        
                        // Fill in the map with actual attendance
                        candidateAttendance.forEach(att => {
                          if (att.jobDay) {
                            weekDaysMap[att.jobDay] = {
                              status: att.status,
                              isSubmitted: att.isSubmitted,
                            };
                          }
                        });
                        
                        // Generate invoice number
                        const invoiceNumber = `INV00${100 + index}`;
                        
                        return (
                          <div className="col-md-4 mb-4" key={candidate.candidateId}>
                            <div className="card p-3">
                              <div className="mb-2">
                                <span className="text-muted">{invoiceNumber}</span>
                                <Button 
                                  variant="outline-danger" 
                                  size="sm" 
                                  className="float-end"
                                  onClick={() => generateInvoice(candidate)}
                                >
                                  Invoice
                                </Button>
                              </div>
                              <h5>{candidate.candidateName}</h5>
                              
                              <div className="d-flex flex-wrap mb-3">
                                <div className="me-2 mb-2 text-center">
                                  <div className="border p-2">AWR</div>
                                  <div className="p-1 text-danger">✕</div>
                                </div>
                                <div className="me-2 mb-2 text-center">
                                  <div className="border p-2">Ts.</div>
                                  <div className="p-1 text-success">✓</div>
                                </div>
                                <div className="me-2 mb-2 text-center">
                                  <div className="border p-2">M</div>
                                  <div className="p-1">
                                    {weekDaysMap['Monday'].status === 'PRESENT' ? 'P' : 
                                     weekDaysMap['Monday'].status === 'ABSENT' ? 'A' : 
                                     weekDaysMap['Monday'].status === 'LEAVE' ? 'L' : '-'}
                                  </div>
                                </div>
                                <div className="me-2 mb-2 text-center">
                                  <div className="border p-2">T</div>
                                  <div className="p-1">
                                    {weekDaysMap['Tuesday'].status === 'PRESENT' ? 'P' : 
                                     weekDaysMap['Tuesday'].status === 'ABSENT' ? 'A' : 
                                     weekDaysMap['Tuesday'].status === 'LEAVE' ? 'L' : '-'}
                                  </div>
                                </div>
                                <div className="me-2 mb-2 text-center">
                                  <div className="border p-2">W</div>
                                  <div className="p-1">
                                    {weekDaysMap['Wednesday'].status === 'PRESENT' ? 'P' : 
                                     weekDaysMap['Wednesday'].status === 'ABSENT' ? 'A' : 
                                     weekDaysMap['Wednesday'].status === 'LEAVE' ? 'L' : '-'}
                                  </div>
                                </div>
                                <div className="me-2 mb-2 text-center">
                                  <div className="border p-2">T</div>
                                  <div className="p-1">
                                    {weekDaysMap['Thursday'].status === 'PRESENT' ? 'P' : 
                                     weekDaysMap['Thursday'].status === 'ABSENT' ? 'A' : 
                                     weekDaysMap['Thursday'].status === 'LEAVE' ? 'L' : '-'}
                                  </div>
                                </div>
                                <div className="me-2 mb-2 text-center">
                                  <div className="border p-2">F</div>
                                  <div className="p-1">
                                    {weekDaysMap['Friday'].status === 'PRESENT' ? 'P' : 
                                     weekDaysMap['Friday'].status === 'ABSENT' ? 'A' : 
                                     weekDaysMap['Friday'].status === 'LEAVE' ? 'L' : '-'}
                                  </div>
                                </div>
                                <div className="me-2 mb-2 text-center">
                                  <div className="border p-2">S</div>
                                  <div className="p-1">
                                    {weekDaysMap['Saturday'].status === 'PRESENT' ? 'P' : 
                                     weekDaysMap['Saturday'].status === 'ABSENT' ? 'A' : 
                                     weekDaysMap['Saturday'].status === 'LEAVE' ? 'L' : '-'}
                                  </div>
                                </div>
                                <div className="mb-2 text-center">
                                  <div className="border p-2">S</div>
                                  <div className="p-1">
                                    {weekDaysMap['Sunday'].status === 'PRESENT' ? 'P' : 
                                     weekDaysMap['Sunday'].status === 'ABSENT' ? 'A' : 
                                     weekDaysMap['Sunday'].status === 'LEAVE' ? 'L' : '-'}
                                  </div>
                                </div>
                              </div>
                              
                              <div className="d-grid gap-2">
                                <Button variant="primary" className="purple-btn" onClick={() => openAttendanceModal(candidate)}>
                                  Mark Attendance
                                </Button>
                                <Button variant="primary" className="purple-btn" onClick={() => openSubmitAttendanceModal(candidate)}>
                                  View Attendance
                                </Button>
                                <Button variant="primary" className="purple-btn" onClick={() => generateInvoice(candidate)}>
                                  <i className="fas fa-file-invoice me-1"></i> Invoice
                                </Button>
                                <Button variant="primary" className="purple-btn" onClick={() => sendEmail(candidate)}>
                                  Send Email
                                </Button>
                                <Button variant="primary" className="purple-btn" onClick={() => fetchMonthlyAttendance(candidate)}>
                                  View Monthly Attendance
                                </Button>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="col-12 text-center p-4">
                        <h4>No candidates found</h4>
                        <p>There are no candidates matching your search criteria.</p>
                      </div>
                    )}
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>

      {/* Mark Attendance Modal */}
      <Modal show={attendanceModal} onHide={() => setAttendanceModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Mark Attendance for {currentCandidate?.candidateName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table bordered striped responsive>
            <thead>
              <tr>
                <th>Day</th>
                <th>Date</th>
                <th>Status</th>
                <th>Hours</th>
                <th>OT Hours</th>
                <th>Bank Holiday OT Hours</th>
                <th>Night Rate Hours</th>
              </tr>
            </thead>
            <tbody>
              {attendanceDays.map((day, index) => (
                <tr key={index}>
                  <td>{day.day}</td>
                  <td>{new Date(day.date).toLocaleDateString()}</td>
                  <td>
                    <Form.Select
                      value={day.status}
                      onChange={(e) => handleStatusChange(index, e.target.value)}
                    >
                      <option value="">Select</option>
                      {attendanceStatus.map((status) => (
                        <option key={status} value={status}>
                          {status}
                        </option>
                      ))}
                    </Form.Select>
                  </td>
                  <td>
                    <Form.Control
                      type="number"
                      value={day.hours}
                      onChange={(e) => handleHoursChange(index, e.target.value)}
                      disabled={day.status !== "PRESENT"}
                    />
                  </td>
                  <td>
                    <Form.Control
                      type="number"
                      value={day.overTimeHours}
                      onChange={(e) => handleOverTimeHoursChange(index, e.target.value)}
                      disabled={day.status !== "PRESENT"}
                    />
                  </td>
                  <td>
                    <Form.Control
                      type="number"
                      value={day.bankHolidayOverTimeHours}
                      onChange={(e) => handleBankHolidayHoursChange(index, e.target.value)}
                      disabled={day.status !== "PRESENT"}
                    />
                  </td>
                  <td>
                    <Form.Control
                      type="number"
                      value={day.nightRateHours}
                      onChange={(e) => handleNightRateHoursChange(index, e.target.value)}
                      disabled={day.status !== "PRESENT"}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setAttendanceModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={markAttendance} disabled={isSavingAttendance}>
            {isSavingAttendance ? "Saving..." : "Save Attendance"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Submit Attendance Modal */}
      <Modal show={submitAttendanceModal} onHide={() => setSubmitAttendanceModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Attendance Details for {currentCandidate?.candidateName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table bordered striped responsive>
            <thead>
              <tr>
                <th>Day</th>
                <th>Date</th>
                <th>Status</th>
                <th>Hours</th>
                <th>OT Hours</th>
                <th>Bank Holiday OT Hours</th>
                <th>Night Rate Hours</th>
              </tr>
            </thead>
            <tbody>
              {attendanceDays.map((day, index) => (
                <tr key={index}>
                  <td>{day.jobDay}</td>
                  <td>{new Date(day.jobDate).toLocaleDateString()}</td>
                  <td>{day.status}</td>
                  <td>{day.hours}</td>
                  <td>{day.overTimeHours}</td>
                  <td>{day.bankHolidayOverTimeHours}</td>
                  <td>{day.nightRateHours}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setSubmitAttendanceModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={submitAttendance} disabled={isSubmittingApprove}>
            {isSubmittingApprove ? "Submitting..." : "Submit & Approve Attendance"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Monthly Attendance Modal */}
      <Modal show={monthlyModal} onHide={() => setMonthlyModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            Monthly Attendance for {currentCandidate?.candidateName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table bordered striped responsive>
            <thead>
              <tr>
                <th>Day</th>
                <th>Date</th>
                <th>Status</th>
                <th>Hours</th>
                <th>OT Hours</th>
                <th>Bank Holiday OT Hours</th>
                <th>Night Rate Hours</th>
              </tr>
            </thead>
            <tbody>
              {monthlyAttendance.map((day, index) => (
                <tr key={index}>
                  <td>{day.jobDay}</td>
                  <td>{new Date(day.jobDate).toLocaleDateString()}</td>
                  <td>{day.status}</td>
                  <td>{day.hours}</td>
                  <td>{day.overTimeHours}</td>
                  <td>{day.bankHolidayOverTimeHours}</td>
                  <td>{day.nightRateHours}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMonthlyModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* SendEmail Component */}
      <SendEmail
        ref={emailComponentRef}
        user={loggedInUser}
        candidateEmail={currentCandidate?.candidateEmail}
        candidateName={currentCandidate?.candidateName}
      />
    </Card>
  );
};

const mapStateToProps = (state) => {
  return {
    token: getLoggenInToken(state),
    loggedInUser: getLoggedInUser(state),
    selectedCompany: state.companies.selectedCompany,
    candidates: getCandidates(state),
  };
};

export default withRouter(connect(mapStateToProps)(RestrictCandidates));
